// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PIgR2","badges":"styles_badges__2kmHo"};